<template>
    <el-tooltip :content="text" placement="top-start">
        <i :class="iconClass" aria-hidden="true"></i>
    </el-tooltip>
</template>

<script>
  export default {
    props: [
      'value', 'text'
    ],

    computed: {
      iconClass() {
        const map = {
          1: 'fa fa-hourglass-start',               // queued
          2: 'fa fa-play-circle',                   // processing
          3: 'fa fa-times-circle text-danger',      // error
          4: 'fa fa-check-circle text-success',     // processed
          5: 'fas fa-undo text-inactive',           // reverted
        };
        return _.get(map, this.value, 'fas fa-question-circle');
      },
    },
  }
</script>
